export default "__VITE_ASSET__f036d699__"